export type MapRegion = {
  latitude: number;
  longitude: number;
  latitudeDelta: number;
  longitudeDelta: number;
};

export type MapCoordinate = Pick<MapRegion, 'latitude' | 'longitude'>;

export type MapInitialRegion = MapCoordinate &
  Partial<Pick<MapRegion, 'latitudeDelta' | 'longitudeDelta'>>;

export type MapViewport = {
  width: number;
  height: number;
};

export const MAP_INITIAL_REGION: MapRegion = {
  latitude: 37,
  longitude: -95,
  latitudeDelta: 30,
  longitudeDelta: 30,
};

export function getMapRegion(initialRegion?: MapInitialRegion): MapRegion {
  const center = isValidMapCoordinate(initialRegion) ? initialRegion : MAP_INITIAL_REGION;
  const latitudeDelta = initialRegion?.latitudeDelta;
  const longitudeDelta = initialRegion?.longitudeDelta;

  return {
    latitude: center.latitude,
    longitude: center.longitude,
    latitudeDelta: isValidMapRegionDelta(latitudeDelta)
      ? latitudeDelta
      : MAP_INITIAL_REGION.latitudeDelta,
    longitudeDelta: isValidMapRegionDelta(longitudeDelta)
      ? longitudeDelta
      : MAP_INITIAL_REGION.longitudeDelta,
  };
}

export function isValidMapCoordinate(
  coordinate?: Partial<MapCoordinate>
): coordinate is MapCoordinate {
  return (
    typeof coordinate?.latitude === 'number' &&
    Number.isFinite(coordinate.latitude) &&
    coordinate.latitude >= -90 &&
    coordinate.latitude <= 90 &&
    typeof coordinate.longitude === 'number' &&
    Number.isFinite(coordinate.longitude) &&
    coordinate.longitude >= -180 &&
    coordinate.longitude <= 180
  );
}

export function isValidMapRegionDelta(delta?: number): delta is number {
  return typeof delta === 'number' && Number.isFinite(delta) && delta > 0;
}
